import React from 'react'

// Utilities

import { setNestedFieldError } from '../../../utilities/helper-functions';

import './Styles.scss';

export default function InputWrapper(props) {
    const {
        formik,
        fieldName,
        label,
        helpText,
        isRequired,
        isGroup,
        isSingleRadioInput,
        children
    } = props;

    const error = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.errors) : formik.errors[fieldName];
    const touched = fieldName.includes('.') ? setNestedFieldError(fieldName, formik.touched) : formik.touched[fieldName];

    return (
        <div className='input-container'>
            <div className={isGroup ? 'input-group-wrapper' : 'input-field-wrapper'}>

                <label
                    htmlFor={fieldName}
                    className={`${error && formik.touched[fieldName] ? 'p-error' : ''} ${isGroup && !(error && touched) ? 'input-group-label' : ''}`}>
                   
                    {label}
                    {isRequired && <span>*</span>}

                </label>

                {/* Input Field */}

                {children}

            </div>

            {helpText &&
            <small className="p-helptext">{helpText}</small>}

            {!isSingleRadioInput && touched && error &&
            <small className="p-error">{touched && error}</small>}

            {isSingleRadioInput && error &&
            <small className="p-error">{error}</small>}

        </div>
    )
}
